import { DefaultTheme } from '@byte-coach/admin-ui-components';
import { createTheme } from '@mui/material/styles';

export function createDefaultTheme(isRTL: boolean) {
  return createTheme({ ...DefaultTheme, direction: isRTL ? 'rtl' : undefined });
};
